(function() {
    'use strict';

    angular
        .module('reportApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$urlRouterProvider', 'GLOBAL_URL', 'CONST_REPORT'];

    function stateConfig($stateProvider, $urlRouterProvider, GLOBAL_URL, CONST_REPORT) {
    	$urlRouterProvider.otherwise("/report-info");
    	
    	$stateProvider.state('report', {
    		  url: '/report-info',
    		  data: {
              	pageTitle: CONST_REPORT.REPORT_LIST
              },
              views: {
              	'content@': {
                      templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-info',  
                      controller: 'ReportController as reportCtr'
                   }
              }
    	})
    	.state('report-contest-payment-detail', {
    		url: '/report-contest-payment-detail',
            data: {
            	pageTitle: CONST_REPORT.REPORT_CONTEST_PAYMENT_DETAIL
            },
            views: {
            	'content@': {
            		templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-contest-payment-detail',  
                    controller: 'ReportController as reportCtr'
                }
            }
        })
    	.state('report-contest-payment-summary', {
    		url: '/report-contest-payment-summary',
            data: {
            	pageTitle: CONST_REPORT.REPORT_CONTEST_PAYMENT_SUMMARY
            },
            views: {
            	'content@': {
            		templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-contest-payment-summary',  
                    controller: 'ReportController as reportCtr'
                }
            }
        })
        .state('report-netoff-summary', {
    		url: '/report-netoff-summary',
            data: {
            	pageTitle: CONST_REPORT.REPORT_NETOFF_SUMMARY
            },
            views: {
            	'content@': {
            		templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-netoff-summary',  
                    controller: 'ReportController as reportCtr'
                }
            }
        })
        .state('report-paid-payment', {
    		url: '/report-paid-payment',
            data: {
            	pageTitle: CONST_REPORT.REPORT_PAID_PAYMENT
            },
            views: {
            	'content@': {
            		templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-paid-payment',  
                    controller: 'ReportController as reportCtr'
                }
            }
        })
        .state('report-tax-invoice-cancel-detail', {
    		url: '/report-tax-invoice-cancel-detail',
            data: {
            	pageTitle: CONST_REPORT.REPORT_TAX_INVOICE_CANCEL_DETAIL
            },
            views: {
            	'content@': {
            		templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-tax-invoice-cancel-detail',  
                    controller: 'ReportController as reportCtr'
                }
            }
        })
        .state('report-tax-invoice-detail', {
    		url: '/report-tax-invoice-detail',
            data: {
            	pageTitle: CONST_REPORT.REPORT_TAX_INVOICE_DETAIL
            },
            views: {
            	'content@': {
            		templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-tax-invoice-detail',  
                    controller: 'ReportController as reportCtr'
                }
            }
        })
        .state('report-tax-invoice-summary', {
    		url: '/report-tax-invoice-summary',
            data: {
            	pageTitle: CONST_REPORT.REPORT_TAX_INVOICE_SUMMARY
            },
            views: {
            	'content@': {
            		templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-tax-invoice-summary',  
                    controller: 'ReportController as reportCtr'
                }
            }
        })
        .state('report-transaction.detail', {
    		url: '/report-transaction.detail',
            data: {
            	pageTitle: CONST_REPORT.REPORT_TAX_INVOICE_SUMMARY
            },
            views: {
            	'content@': {
            		templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-tax-invoice-summary',  
                    controller: 'ReportController as reportCtr'
                }
            }
        })
        .state('report-invalid-id', {
    		url: '/report-invalid-id',
            data: {
            	pageTitle: CONST_REPORT.REPORT_INVALID_ID
            },
            views: {
            	'content@': {
            		templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-invalid-id',  
                    controller: 'ReportController as reportCtr'
                }
            }
        })
        .state('report-fatca', {
        	url: '/report-fatca',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_FATCA
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-fatca',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-day-end-collection', {
        	url: '/report-day-end-collection',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_DAY_END_COLLECTION
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-day-end-collection',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-netoff-detail', {
        	url: '/report-netoff-detail',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_NETOFF_DETAIL
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-netoff-detail',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-payment-checking-valid', {
        	url: '/report-payment-checking-valid',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_PAYMENT_CHECKING_VALID
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-payment-checking-valid',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-payment-checking-valid-log', {
        	url: '/report-payment-checking-valid-log',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_PAYMENT_CHECKING_VALID_LOG
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-payment-checking-valid-log',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-payment-checking-valid-summary', {
        	url: '/report-payment-checking-valid-summary',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_PAYMENT_CHECKING_VALID_SUMMARY
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-payment-checking-valid-summary',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
         .state('report-investment-detail', {
        	url: '/report-investment-detail',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_INVESTMENT_DETAIL
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-investment-detail',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-collection-at-home', {
        	url: '/report-collection-at-home',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_COLLECTION_AT_HOME
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-collection-at-home',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-transaction-payment-request', {
        	url: '/report-transaction-payment-request',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_TRANSACTION_PAYMENT_REQUEST
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-transaction-payment-request',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-return-letter-details', {
        	url: '/report-return-letter-details',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_RETURN_LETTER_DETAILS
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-return-letter-details',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-return-letter-summary', {
        	url: '/report-return-letter-summary',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_RETURN_LETTER_SUMMARY
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-return-letter-summary',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-agent-info', {
        	url: '/report-agent-info',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_AGENT_INFO
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-agent-info',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-advance_payment_pay_off', {
        	url: '/report-advance_payment_pay_off',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_ADVANCE_PAYMENT_AND_PAY_OFF
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-advance-payment-pay-off',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
        .state('report-submit-refund', {
        	url: '/report-submit-refund',
        	data: {
        		pageTitle: CONST_REPORT.REPORT_SUBMIT_REFUND
        	},
        	views: {
        		'content@': {
        			templateUrl: GLOBAL_URL + 'partial?uri=ga/report/report-submit-refund',  
        			controller: 'ReportController as reportCtr'
        		}
        	}
        })
    }
})();
